import type { TFunction } from 'i18next';

interface DuplicateWarehouseDocument {
    code: 'WAREHOUSE_DOCUMENT_ALREADY_IMPORTED';
    documentNumber: string;
    warehouseName: string;
    firstImportedAt?: string | null;
}

export const getWarehouseImportConflictMessage = (error: unknown, translate: TFunction): string | null => {
    if (!error || typeof error !== 'object') {
        return null;
    }
    // importWarehousePdfDocument rejects with the response body through skipErrorInterceptor.
    const conflict = error as Partial<DuplicateWarehouseDocument>;
    if (conflict.code !== 'WAREHOUSE_DOCUMENT_ALREADY_IMPORTED'
        || typeof conflict.documentNumber !== 'string'
        || typeof conflict.warehouseName !== 'string') {
        return null;
    }

    // The backend returns LocalDateTime; keep its calendar date without a timezone conversion.
    const date = typeof conflict.firstImportedAt === 'string'
        ? /^(\d{4})-(\d{2})-(\d{2})T/.exec(conflict.firstImportedAt)
        : null;
    return translate(date ? 'table.warehousePdfImportAlreadyImported' : 'table.warehousePdfImportAlreadyImportedWithoutDate', {
        documentNumber: conflict.documentNumber,
        warehouseName: conflict.warehouseName,
        date: date ? `${date[3]}.${date[2]}.${date[1]}` : '',
    });
};
